import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'situapi-action-confirmation-dialog',
  templateUrl: './situapi-action-confirmation-dialog.component.html',
  styleUrls: ['./situapi-action-confirmation-dialog.component.less']
})
export class SituApiActionConfirmationDialogComponent {
  copied: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<SituApiActionConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SituApiActionConfirmationDialogData,
    private clipboard: Clipboard) {}

  cancelClick(): void {
    this.dialogRef.close();
  }

  confirmCopyClick(): void {
    this.dialogRef.close();
  }

  copyKeyToClipboard() {
    this.copied = true;
    this.clipboard.copy(this.data.oneTimeApiKey);
  }
}

export interface SituApiActionConfirmationDialogData {
  oneTimeApiKey: string;
  newKeyRequest: boolean
  clientName: string
}